import axios from "axios"
import { baseURL } from "../config/api";

export const getCustomersExtraInformationsByCustomerId = (customerId: number, tenantId: string) => {
    return getFetch(`customerExtraInformation/GetCustomerExtraInformationsByCustomerId/${customerId}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}